import { ArchivoAcreditadoService } from './src/services/archivo.acreditado.service';

export type { ArchivoAcreditado } from './src/services/suite.interfaces';

export const archivoAcreditadoService = new ArchivoAcreditadoService();

export default archivoAcreditadoService;
